import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import {
  AbstractValueAccessor,
  MakeProvider,
} from '../../abstracts/abstract-value-accessor';

@Component({
  selector: 'brn-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [MakeProvider(InputComponent)],
})
export class InputComponent
  extends AbstractValueAccessor
  implements OnInit, OnDestroy {
  @Input('placeholder') placeholder: string = 'Set value...';
  @Input() delay: number = 0;
  @Input() inline: boolean = false;
  @Output() blur = new EventEmitter<string>();
  @Output() change = new EventEmitter<string>();
  @ViewChild('inputField') inputField!: ElementRef;
  changed = false;
  private unsubscribe$: Subject<any> = new Subject();

  ngOnInit() {
    this.inlineClass = this.inline;

    setTimeout(() => {
      if (this.delay) {
        fromEvent(this.inputField.nativeElement, 'input')
          .pipe(takeUntil(this.unsubscribe$), debounceTime(this.delay))
          .subscribe(() => {
            this.handleBlur();
          });
      }
    }, 100);
  }

  handleInput() {
    if (!this.changed) {
      this.changed = true;
    }

    if (this.inline) {
      const s = this.value.replace(/[\r\n]+/g, '');
      if (s !== this.value) {
        setTimeout(() => {
          this.value = s;
        }, 0);
      }
    }
  }

  handleBlur() {
    this.blur.emit(this.value);

    if (this.changed) {
      this.change.emit(this.value);
      this.changed = false;
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  @HostBinding('class.inline') inlineClass: boolean = false;
}
